import React, { Component } from 'react';
import Cookies from 'js-cookie'
import {connect} from 'react-redux'
import * as configActions from '../../store/action/config'
import localStore from 'src/utils/local-storage'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
class PublicLayout extends Component{

  constructor(props) {
      super();     
  }  

  componentDidMount () {          
      let accesstoken = Cookies.get("jwt");
      if(accesstoken && accesstoken !== ''){
          let user = localStore.get('_user');
          if(user){
            // window.location.href = '/posts';
          }else{
            Cookies.remove("jwt");
          }          
      }
      const cls = ["sidebar-mini", "layout-fixed"];
      document.body.classList.add(...cls);
  }

  render() {
      return (
      <div className="wrapper">
        <ToastContainer autoClose={2000} position="bottom-left" closeOnClick />
         {this.props.children}  
      </div>
      );
  }
}
export default connect( store => {
  return {
    login: store.loginInfo
    };
  } , dispatch => {
  return {
    getListRoleRule: (value) => { dispatch(configActions.getListRoleRule(value))},
    getListCate: (value) => { dispatch(configActions.getListCate(value))},
  }
})(PublicLayout)
